import _typeof from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/typeof";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.string.ends-with.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.split.js";
import CryptoJS from 'crypto-js';
import snakeCase from 'lodash/snakeCase';
import camelCase from 'lodash/camelCase';
import { store } from '@/store';
/**
 * Hash a string.
 *
 * @param {String} str string to be hashed
 * @param {String} alg string defining algorithm to be used in hashing (optional)
 *
 * @returns {Object}
 */

export function hash(str) {
  var alg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'SHA-256';

  if (alg === 'SHA-256') {
    return CryptoJS.SHA256(str).toString();
  }
}
/**
 * Camelise object data properties (recursively).
 *
 * @param {Mixed} obj object to be camelised
 * @param {Boolean} recursive decides if camelisation should be applied recursively
 *
 * @returns {Object}
 */

export function camelise(obj) {
  var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return casify(obj, 'camel', recursive);
}
/**
 * Snakify object data properties (recursively).
 *
 * @param {Object} obj object to be snakified
 * @param {Boolean} recursive decides if snakification should be applied recursively
 *
 * @returns {Object}
 */

export function snakify(obj) {
  var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return casify(obj, 'snake', recursive);
}
/**
 * Change the case pattern of object keys (recursively).
 *
 * @param {Object} obj object to be operated on
 * @param {String} targetCase the desired target case
 * @param {Boolean} recursive decides if case change should be applied recursively
 *
 * @returns {Object}
 */

export function casify(obj) {
  var targetCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'snake';
  var recursive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!obj || !(Array.isArray(obj) || _typeof(obj) === 'object')) {
    return obj;
  }

  var acceptedCases = ['snake', 'camel'];

  if (!acceptedCases.includes(targetCase)) {
    console.error('casify was provided with an invalid case - accepted case include: ', acceptedCases);
    return;
  }

  var changeCaseFunction = targetCase === 'snake' ? snakeCase : camelCase;
  var isArray = Array.isArray(obj);
  var keys = isArray ? obj : Object.keys(obj);
  var changed = isArray ? [] : {};

  for (var i in keys) {
    var key = isArray ? i : changeCaseFunction(keys[i]);
    var val = isArray ? obj[i] : obj[keys[i]];

    if (recursive && (Array.isArray(val) || _typeof(val) === 'object')) {
      changed[key] = casify(val, targetCase);
    } else {
      changed[key] = val;
    }
  }

  return changed;
}
/**
 * Ensure that a value is in array, if it is not one already
 *
 * @param {Mixed} value value to be operated on
 *
 * @returns {Array}
 */

export function arrayify(value) {
  return Array.isArray(value) ? value : [value];
}
/**
 * Checks for a valid slug to redirect through for sets off to check the url queryString
 *
 * @param {Object} storeUrlParams Object from the store of the urlParams (passed from store.state.checkIn.urlParams)
 * @param {Object} to the path of the current route from vue router ($route)
 * @param {Function} redirect the redirect function created in the router index
 *
 * @returns null
 */

export function checkForSlug(storeUrlParams, to, redirect) {
  if (storeUrlParams !== null && storeUrlParams !== void 0 && storeUrlParams.slug) {
    // send to the initial setup of the slug
    redirect("/".concat(storeUrlParams.slug));
  } else {
    // Get any url params that are present.
    var urlParams = queryParamFetch(to, 'web');
    checkThroughParams(urlParams, redirect);
  }
}
/**
 * Checks through the url query string for a valid slug and query paramters to keep and pass through.
 * If no valid slugs found then we send the user to the leave feedback page.
 *
 * @param {Object} storeUrlParams Object from the store of the urlParams (passed from store.state.checkIn.urlParams)
 * @param {Object} urlParams the query parameters to check through.
 * @param {Function} redirect the redirect function created in the router index
 *
 * @returns null
 */

export function checkThroughParams(urlParams, redirect) {
  if (urlParams.slug) {
    var queryString = '';
    Object.keys(urlParams).forEach(function (key) {
      // bail out if its the slug as we don't need to pass that through
      if (key === 'slug') {
        return;
      }

      queryString += "".concat(key, "=").concat(urlParams[key], "&");
    }); // remove last character form the querystring if its a '&'

    queryString = queryString.endsWith('&') && queryString.slice(0, -1);
    redirect("/".concat(urlParams.slug).concat(queryString ? '?' + queryString : ''));
  } else {
    // We don't have a slug so no point trying to setup the config
    // When loading the 404 page, don't try to resume an in-progress survey instead.
    // store.dispatch('settings/resetAllModuleStates');
    // Weird issues with routing to 404 so we'll just do a horrible thing outside of vue-router.
    window.location.replace("".concat(window.location.origin, "/error-404")); // redirect('/error-404');
  }
}
/**
 * Get the query params from the vue $route object
 *
 * @param {Object} _$route vue route object
 * @param {String} device the device the app is running on
 *
 * @returns {Object}
 */

export function queryParamFetch() {
  var _$route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var device = arguments.length > 1 ? arguments[1] : undefined;
  var params = {};

  if (device === 'web') {
    for (var key in _$route.query) {
      var value = _$route.query[key];
      params[key] = value;
    }

    if (((_$route.matched[0] || {}).path || '').match(/^\/?\*$/g) !== null) {
      var _params = _$route.path.match(/^\/([a-zA-Z0-9\-]+)\/?(.*)\/?$/);

      params['slug'] = _params[1];

      if (_params[2]) {
        _params = _params[2].split('/').filter(function (e) {
          return e !== '' || typeof e !== 'undefined';
        });

        if (_params.length == 1 && _params[0]) {
          params['pin'] = _params[0];
        } else if (_params[0] && _params[1]) {
          var pinType = ['pve'].includes(_params[0]) ? _params[0] : 'pin';
          params[pinType] = _params[1];
        }
      }
    }
  } //else if (device === 'app') {
  // Logger.debug('Running app specific setup')
  // store known location params
  // ...
  //}


  return params || {};
}
export function canLoadMoreItems(scrollVal, currentItems, totalItems, containerRef) {
  // get the maximum scroll value of the container
  var maxScroll = containerRef.scrollHeight - containerRef.clientHeight; // set a point at where the scroll value passes then we will look to load more items

  var loadMorePoint = Math.ceil(maxScroll * 0.8); // check to see if there are more items that can be added to the list of products

  var canLoadMore = totalItems.length > currentItems.length; // calculate if more products should be added

  return scrollVal > loadMorePoint && canLoadMore;
}